import { render, staticRenderFns } from "./ProjectCustomers.component.vue?vue&type=template&id=5e7c6c98&scoped=true"
import script from "./ProjectCustomers.component.vue?vue&type=script&lang=js"
export * from "./ProjectCustomers.component.vue?vue&type=script&lang=js"
import style0 from "./ProjectCustomers.component.vue?vue&type=style&index=0&id=5e7c6c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7c6c98",
  null
  
)

export default component.exports